export enum AccessType {
	LIMITED = 'LIMITED',
	OPEN_ACCESS = 'OPEN_ACCESS',
}
